<template>
  <b-row class="align-items-center">
    <b-col class="d-flex justify-content-between align-items-center">
      <b-breadcrumb v-if="breadcrumb && breadcrumb.length" :items="breadcrumb"></b-breadcrumb>

      <b-button
        v-if="showBackButton"
        class="medium blue ms-auto"
        :style="buttonHeight ? { height: `${buttonHeight}px`, marginRight: 0 } : { marginRight: 0 }"
        @click="$router.go(-1)"
      >
        Voltar
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    breadcrumb: {
      type: Array,
      default: () => [],
    },
    showBackButton: {
      type: Boolean,
      default: true,
    },
    buttonHeight: {
      type: Number,
    },
  },
};
</script>
